import React from 'react';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import { useEffect, useState, useRef } from 'react';
import upsort from '../../images/common/upsort.png'
import downsort from '../../images/common/downsort.png'
import '../../scss/contact.scss';
import data from '../data/contact.json';
import edit from '../../images/common/edit.png'
import trash from '../../images/common/trash.png'
import editDark from '../../images/common/edit-dark.png'
import trashDark from '../../images/common/trash-dark.png'
// import PageChange from '../Reusables/PageChange';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import SearchSection from '../Reusables/SearchSection';
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList, parseEntityId, parseNewContactEmail } from '../../store/Actions';
import PageChange from '../Reusables/Pagination';
// import SearchSection from '../Reusables/SearchSection';
import bluedownarrow from '../../images/common/bluedownarrow.png';
import blueuparrow from '../../images/common/blueuparrow.png';
import { useNavigate, useLocation} from "react-router-dom";
import getContact from '../actions/Contacts';
import getResponse from '../actions/Project';
import DeleteItem from '../popups/DeleteItem';
import Spinner from '../Reusables/Spinner';
import { useSelector } from 'react-redux';
import RefreshToken from '../actions/RefreshToken';
import Upload from '../popups/Upload';
import Snackbars from '../Reusables/Snackbar';
import Entries from '../Reusables/Entries';
import { convertUTCToPST } from '../Reusables/Function';

function ClickOutside(ref, setFilter) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
            setFilter(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
}
function Contacts(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Contacts", "url": "contacts/list"}
    ]
    const [filterdetails, setFilter] = useState(false);
    const contactEmail = useSelector((state) => state.contactEmail);
    const filterwrapperRef = useRef(null);
    ClickOutside(filterwrapperRef, setFilter);
    const [page, setPage] = useState('1');
    const [projectlists, setProjectlists] = useState([]);
    const [totalpage, setTotalPage] = useState(null);
    const [entitydropdown, setEntitydropdown] = useState(false);
    const [contactdata, setContactdata] = useState([]);
    const [entitydropdownlist, setEntitydropdownlist] = useState([]);
    const [projectTypeDropdown, setProjectTypeDropdown] = useState(false);
    const [isDeleted, setDeleted] = useState(false);
    const [issort, setSort] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [show, setShow] = useState(false);
    const [deleteBrandId, setDeleteBrandId] = useState(null);
    const [deleteProjectId, setDeleteProjectId] = useState(null);
    const [deleteproject, setDeleteproject] = useState('');
    const [downloadtype, setDownloadtype] = useState('');
    const [downloadarray, setDownloadarray] = useState([]);
    const [countList, setCountList] = useState([]);
    const [showImportPopup, setShowImportPopup] = useState(false);
    const [loadend, setLoadEnd] = useState(false);
    const [uploaderror, setUploaderror] = useState('');
    const [created, setCreate] = useState(false);
    const [uploadstate, setUpload] = useState(false);
    const [openEmailSuccess, setOpenEmailSuccess] = useState(null);
    const [emailSuccessMessage, setEmailSuccessMessage] = useState(null);
    const [limit, setLimit] = useState(30);

    const handleImportPopupClose = () => setShowImportPopup(false);

    const pageList = [
        { "name": "Home", "url": "" },
        { "name": "Contacts", "url": "contacts/list" }
    ];
    const params = new URLSearchParams(location.search);
    const sort = params.has('sort') ? (params.get('sort') == "Property" ? "Entity" : params.get('sort')) : ''
    const sort_order = params.has('sort_order') ? params.get('sort_order') : ''

    const [searchValues, setSearchValues] = useState({
        isFilter: true,
        isCreate: true,
        placeholder: "Search Contacts",
    })
    const createNewValues = {
        page: "create-project",
    }
    const editValues = {
        page: "edit-project",
    }
    const headers = [
        { label: "First Name", key: "firstName" },
        { label: "Last Name", key: "lastName" },
        { label: "Portal", key: "portal" },
        { label: "Property Code", key: "propertyCodes" },
        { label: "Email", key: "email" },
        { label: "Phone Number", key: "phoneNumber" },
        { label: "Last Updated", key: "lastUpdatedTime" },
    ];  
    const filename = 'Contacts';
    const projectTypeList = [
        {
            id: 1,
            name: "Guest Consumer",
            type: "guest-consumer"
        },
        {
            id: 2,
            name: "Event Planner",
            type: "event-planner"
        }
    ]

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(parseBreadcrumbsList(breadcrumbsList));
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const pagenum = params.has('page') ? params.get('page') : 1
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const search = params.has('search') ? params.get('search') : '';
        const entity = params.has('portalId') ? params.get('portalId') : '';
        const projectType = params.has('projectType') ? params.get('projectType') : '';
        console.log(entity);
        if (search || sort || sort_order || entity || projectType) {
            splitpath();
        } 
        else {
            contactApi(`/api/contacts/list?limit=${limit}&page=${pagenum}`);
            contactDownloadApi(`/api/contacts/list?limit=${limit}&page=${pagenum}&download=true`);
        }
        console.log(page);
    }, [page,isDeleted,entitydropdown,projectTypeDropdown,issort,deleteproject, uploadstate, limit])

    const contactDownloadApi = (endpoint) => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getContact.GetContactList(endpoint, accesstoken, (response) => {
                    if(response) {
                     setDownloadarray(response.data.data)
                    }
                 });
            } 
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    const contactApi = (endpoint) => {
        function CallAPI(accesstoken) {
            console.log('projecttoken', accesstoken);
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getContact.GetContactList(endpoint, accesstoken, (data) => {
                    console.log("respsonse", data); 
                    if (data.status == 200) {
                        console.log("Fetched data", data.data.data);
                        const contactdata = data.data.data;
                        setContactdata(contactdata);
                        setTotalPage(data.data.totalPages);
                        setLoading(false);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });

                getContact.GetContactList(`/api/contacts/list?limit=${limit}&page=1`, accesstoken, (data) => {
                    if (data.status == 200) {
                        setCountList(data.data.data);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            } 
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    const splitpath = () => {
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : '';
        const entity = params.has('portalId') ? params.get('portalId') : '';
        const projectType = params.has('projectType') ? params.get('projectType') : '';
        const pagenum = params.has('page') ? params.get('page') : 1
        
        contactApi(`/api/contacts/list?limit=${limit}&page=${pagenum}${search ? `&search=${search}` : ''}${sort ? `&sortKey=${sort}` : ''}${sort_order ? `&sortOrder=${sort_order}` : ''}${entity ? `&brandId=${entity}` : ''}${projectType ? `&projectType=${projectType}` : ''}`);
        contactDownloadApi(`/api/contacts/list?limit=${limit}&page=${pagenum}&download=true${search ? `&search=${search}` : ''}${sort ? `&sortKey=${sort}` : ''}${sort_order ? `&sortOrder=${sort_order}` : ''}${entity ? `&brandId=${entity}` : ''}${projectType ? `&projectType=${projectType}` : ''}`)
    }
    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
    }
    function changeBackground(e, index) {
        // const id = e.target.parentElement.id
        const element = document.getElementById('edit'+index)
        const elements = document.getElementById('trash'+index)
        element.src = editDark;
        elements.src = trashDark;

    }
    function removeBackground(e, index) {
        // const id = e.target.parentElement.id;
        const element = document.getElementById('edit'+index);
        const elements = document.getElementById('trash'+index);
        element.src = edit;
        elements.src = trash;
    }
    function Filter() {
        function CallAPI(accesstoken) {
            console.log('projecttoken', accesstoken);
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                setFilter(!filterdetails);
                const endpoint = "/api/brand/dropdown?parent=true";
                getResponse.GetEntityDropdown(accesstoken, endpoint, (response) => { 
                    if(response.status == 200) {
                        setEntitydropdownlist(response.data.data);
                    } else if(response.status == 401) {
                        navigate("/login")
                    }    
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }
    function GetEntityParam(entitydropdownlist) {
        const params = new URLSearchParams(location.search);
        const entity = params.get('portalId');
        entitydropdownlist.map((item) => { 
            if(item.idBrand === Number(entity)) {
                if(document.getElementsByClassName('entity-dropdown-name')[0]) {
                    document.getElementsByClassName('entity-dropdown-name')[0].innerHTML = item.name;
                }
            }   
        })      
    }
    function GetProjectTypeParam(projectTypeList) {
        const params = new URLSearchParams(location.search);
        const projectType = params.get('projectType');
        projectTypeList.map((item) => { 
            if(item.type === projectType) {
                console.log("[PROJECT TYPE] ", projectType, item.name)
                if(document.getElementsByClassName('project-type-dropdown-name')[0]) {
                    document.getElementsByClassName('project-type-dropdown-name')[0].innerHTML = item.name;
                }
            }      
        })      
    }
    function EntitySeclect(item) {
        setEntitydropdown(false);

        const projectType = params.has('projectType') ? params.get('projectType') : '';
        document.getElementsByClassName('entity-dropdown-name')[0].innerHTML = item.name;
        navigate(`/contacts/list?page=1&portalId=${item.idBrand}${projectType ? `&projectType=${projectType}` : ''}`);
    }
    function ProjectTypeSelect(item) {
        setProjectTypeDropdown(false);

        const entity = params.has('portalId') ? params.get('portalId') : '';
        document.getElementsByClassName('project-type-dropdown-name')[0].innerHTML = item.name;
        navigate(`/contacts/list?page=1&projectType=${item.type}${entity ? `&portalId=${entity}` : ''}`);
    }
    function EntityOption() {
        setEntitydropdown(false);
        document.getElementsByClassName('entity-dropdown-name')[0].innerHTML = "All";
        const params = new URLSearchParams(location.search);
        navigate(`/contacts/list?page=1`);
    }
    function ProjectTypeOption() {
        setProjectTypeDropdown(false);
        document.getElementsByClassName('project-type-dropdown-name')[0].innerHTML = "All";
        navigate(`/contacts/list?page=1`);
    }
    function EntityDropdown() {
        setEntitydropdown(!entitydropdown);
    }
    function ProjectTypeDropdown() {
        setProjectTypeDropdown(!projectTypeDropdown);
    }
    function SortProject(dataset) {
        const params = new URLSearchParams(location.search);
        const search = params.has('search') ? params.get('search') : '';
        let sortBy = dataset.sortBy;
        let sortType = dataset.sortType;
        navigate(`/contacts/list?page=1${search ? `&search=${search}`: ''}&sort=${sortBy == "Entity" ? "Property" : sortBy}&sort_order=${sortType}`);
        setSort(!issort)
    }
    function toCreateNewContact() {
        navigate('/contacts/new');
        dispatch(parseEntityId(null))
    }
    function contactEdit(event,id) {
        event.stopPropagation();
        navigate(`/contacts/${id}/edit` ,{ state: editValues })
    }
    function HandleChange(pages) {
        setPage(pages);
        console.log(pages);
        // navigate(`/contacts/list?page=${pages}`);
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : ''
        const search = params.has('search') ? params.get('search') : ''
        const entity = params.has('portalId') ? params.get('portalId') : ''
        const projectType = params.has('projectType') ? params.get('projectType') : ''
        navigate(`/contacts/list?page=${pages}${sort ? `&sort=${sort == "Entity" ? "Property" : sort}`: ''}${sort_order ? `&sort_order=${sort_order}`: ''}${search ? `&search=${search}`: ''}${entity ? `&portalId=${entity}` : ''}${projectType ? `&portalId=${projectType}` : ''}`);
        window.scroll(0, 0);
    }
    function NavigatetoInfo(id) {
        navigate(`/contacts/${id}/view`)
    }
    const callSearchApi = (query) => {
        const params = new URLSearchParams(location.search);
        const sort = params.has('sort') ? params.get('sort') : ''
        const sort_order = params.has('sort_order') ? params.get('sort_order') : '';

        contactApi(`/api/contacts/list?limit=${limit}&page=1&search=${query}${sort ? `&sortKey=${sort}` : ''}${sort_order ? `&sortOrder=${sort_order}` : ''}`);
        contactDownloadApi(`/api/contacts/list?limit=${limit}&page=1&download=true&search=${query}${sort ? `&sortKey=${sort}` : ''}${sort_order ? `&sortOrder=${sort_order}` : ''}`)
        navigate(`/contacts/list?page=1${sort ? `&sort=${sort == "Entity" ? "Property" : sort}`: ''}${sort_order ? `&sort_order=${sort_order}`: ''}${query ? `&search=${query}`: ''}`);
    }
    function deleteContact() {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getContact.DeleteContact(`/api/contacts/delete?contactId=${deleteProjectId}`, accesstoken,(data) => {
                    if (data.status == 200) {
                        console.log("Delete Brand", data.data.data);
                        handleClose();
                        setDeleteproject(deleteProjectId);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        RefreshToken((accesstoken) => CallAPI(accesstoken));

    }
    function deleteBrand(event, id) {
        event.stopPropagation();
        setDeleteProjectId(id);
        handleShow();
    }

    const openImportPopup = () => {
        setShowImportPopup(true);
        setLoadEnd(false);
        setUploaderror('');
        setCreate(!created);
    }

    useEffect(() => {
        console.log("New Contact ", contactEmail)
        if(contactEmail != "") {
            setOpenEmailSuccess(true);
            setEmailSuccessMessage(`User added successfully. Password reset link is emailed to ${contactEmail}`);
        }
    }, [contactEmail])

    const handleSnackbarClose = (value) => {
        setOpenEmailSuccess(value);
        dispatch(parseNewContactEmail(""));
    }

    const handleEntryDropdown = (value) => {
        setLimit(value);
        HandleChange(1);
    }

    return (
        <div className='contacts-list-page'>
            <Header />
            <div className='row contacts-section'>
                <Sidebar />
                <div className="col-10 contact-list">
                    <div className="contacts">
                        <Breadcrumbs pageList={pageList}/>
                        <div className='header-list'>
                            <Entries handleEntryDropdown={handleEntryDropdown} page="Contacts"/>
                            <SearchSection values={searchValues} handleFilter={Filter} setDownloadtype="" downloadtype=""
                            downloadarray={downloadarray} headers={headers} filename={filename}
                            callSearchApi={(query) => callSearchApi(query)} navigateTo={toCreateNewContact} pageType="Contacts"
                            openImportPopup={openImportPopup}/>
                            {filterdetails &&
                                <>
                                <div className='filter-details' ref={filterwrapperRef}>
                                    <div className='entity-details'>
                                        <div className='entity-heading heading'>Portal</div>
                                        <div className='entity-dropdown dropdown'>
                                            <div className='entity-dropdown-inner dropdown-inner' onClick={EntityDropdown}>
                                                <div className='entity-dropdown-name dropdown-name'>{new URLSearchParams(location.search).has('portalId') ? GetEntityParam(entitydropdownlist) : "All"}</div>
                                                <img className='arrow'  src={entitydropdown ? blueuparrow : bluedownarrow} alt=""></img>
                                            </div>
                                            {countList != null && countList.length > 0 &&
                                            entitydropdown &&
                                            <div className='dropdown-content'>
                                                <div className='dropdown-content-inner' onClick={EntityOption}>All</div>
                                                {
                                                    entitydropdownlist.map((item, index) => {
                                                        return (
                                                            <>
                                                                <div className='dropdown-content-inner' key={index} onClick={() => EntitySeclect(item)}>{item.name}</div>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <div className='project-type-details'>
                                        <div className='project-type-heading heading'>Project Type</div>
                                        <div className='project-type-dropdown dropdown'>
                                            <div className='project-type-dropdown-inner dropdown-inner' onClick={ProjectTypeDropdown}>
                                                <div className='project-type-dropdown-name dropdown-name'>{new URLSearchParams(location.search).has('projectType') ? GetProjectTypeParam(projectTypeList) : "All"}</div>
                                                <img className='arrow'  src={projectTypeDropdown ? blueuparrow : bluedownarrow} alt=""></img>
                                            </div>
                                            {countList != null && countList.length > 0 &&
                                            projectTypeDropdown &&
                                            <div className='dropdown-content'>
                                                <div className='dropdown-content-inner' onClick={ProjectTypeOption}>All</div>
                                                {
                                                    projectTypeList.map((item, index) => {
                                                        return (
                                                            <>
                                                                <div className='dropdown-content-inner' key={index} onClick={() => ProjectTypeSelect(item)}>{item.name}</div>
                                                            </>
                                                        )
                                                    })
                                                }
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                    
                                <div className='filter-details-arrow'></div>
                                </>
                            }
                            </div>
                            <div id="print" className="table-scroll">
                            {isLoading ?
                                (<Spinner/>) :
                                (<table>
                                    <thead>
                                        <tr className="heading-row">
                                            <th className='heading-data' style={{minWidth: "10px"}}></th>
                                            <th className="heading-data" style={{textAlign: "left", minWidth: "130px"}}>
                                                <div className='heading-arrows'>
                                                    <div>First Name</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'FirstName' && sort_order === 'Ascending') && 
                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='FirstName' data-sort-type='Ascending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sort === 'FirstName' && sort_order === 'Descending') && 
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='FirstName' data-sort-type='Descending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="heading-data" style={{textAlign: "left", minWidth: "143px"}}>
                                                <div className='heading-arrows'>
                                                    <div>Last Name</div>
                                                    <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'LastName' && sort_order === 'Ascending') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='LastName' data-sort-type='Ascending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'LastName' && sort_order === 'Descending') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='LastName' data-sort-type='Descending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }                                            
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="heading-data" style={{textAlign: "left",minWidth: "148px"}}>
                                                <div className='heading-arrows'>
                                                    <div>Portal</div>
                                                    <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'Portal' && sort_order === 'Ascending') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='Portal' data-sort-type='Ascending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'Portal' && sort_order === 'Descending') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='Portal' data-sort-type='Descending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }                                             
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="heading-data" style={{textAlign: "left",minWidth: "220px"}}>
                                                <div className='heading-arrows'>
                                                    <div>Property Code</div>
                                                    <div className='sort-arrows'>
                                                        {
                                                            !(sort === 'Property Code' && sort_order === 'Ascending') &&
                                                            <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='Property Code' data-sort-type='Ascending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }
                                                        {
                                                            !(sort === 'Property Code' && sort_order === 'Descending') &&
                                                            <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='Property Code' data-sort-type='Descending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                        }  
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="heading-data" style={{textAlign: "left", minWidth: "200px"}}>
                                                <div className='heading-arrows'>
                                                    <div>Email Id</div>
                                                    <div className='sort-arrows'>
                                                                                               
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="heading-data" style={{textAlign: "left", minWidth: "139px"}}>
                                                <div className='heading-arrows'>
                                                    <div>Phone</div>
                                                    <div className='sort-arrows'>
                                                                                                
                                                    </div>
                                                </div>
                                            </th>
                                            <th className="heading-data" style={{textAlign: "left",minWidth: "154px"}}>
                                                <div className='heading-arrows'>
                                                    <div>Last Updated</div>
                                                    {/* <div className='sort-arrows'>
                                                    {
                                                        !(sort === 'LastUpdated' && sort_order === 'Ascending') &&
                                                        <img className='uparrow' src={upsort} alt="uparrow" data-sort-by='LastUpdated' data-sort-type='Ascending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }
                                                    {
                                                        !(sort === 'LastUpdated' && sort_order === 'Descending') &&
                                                        <img className='downarrow' src={downsort} alt="downarrow" data-sort-by='LastUpdated' data-sort-type='Descending' onClick={(e) => SortProject(e.target.dataset)}></img>
                                                    }                                             
                                                    </div> */}
                                                </div>
                                            </th>
                                            <th className="heading-data">
                                                <div className='heading-arrows action-heading' style={{minWidth: "108px"}}>
                                                    <div>Actions</div>
                                                    
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    {
                                    contactdata && contactdata.length === 0 ? <p className="no-result">No results found</p> :
                                        <tbody>
                                        {
                                            contactdata && contactdata.length > 0 && contactdata.map((list,index) => {
                                            return <tr onMouseOver={(e) => changeBackground(e, index)} onMouseLeave={(e) => removeBackground(e, index)} id={index} onClick={() => NavigatetoInfo(list.idContacts)} className='details-list-row'>
                                            <td className='details-list-data marking-data' style={{minWidth: "10px"}}>
                                                    { (list.cmsStatus != null && list.cmsStatus != 2) &&
                                                        <div className='marking' style={{background: list.cmsStatus == 1 ? '#E25555' : '#FFA500'}}></div>
                                                    }
                                                </td>
                                            <td className='details-list-data'>{list.firstName}</td>
                                                <td className='details-list-data'>{list.lastName}</td>
                                                <td className='details-list-data'>{list.brand}</td>
                                                <td className='details-list-data details-list-property-data'>{list.propertyCodes}</td>
                                                <td className='details-list-data'>{list.email}</td>
                                                <td className='details-list-data'>{list.phoneNumber}</td>
                                                <td className='details-list-data'>{list.lastUpdatedTime && convertUTCToPST(list.lastUpdatedTime + 'Z', "updates")}</td>
                                                <td className='details-list-data action'>
                                                    <img  className='edit' onClick={(event, index) => contactEdit(event,list.idContacts)} id={'edit'+index} src={edit} alt="edit"></img>
                                                    <img className='trash' onClick={(event) => deleteBrand(event,list.idContacts)} id={'trash'+index} src={trash} alt="delete "></img>
                                                </td>
                                            </tr>
                                            })
                                        }
                                        </tbody>
                                    }
                                </table>)}
                            </div>
                    </div>
                    <div className="pagination-contact-list">
                        <PageChange  page={page} setPage={setPage} totalpage={totalpage} HandleChange={HandleChange}></PageChange>
                    </div>
                </div>
            </div>
            <Footer />
            <DeleteItem show={show} handleClose={handleClose} deleteApiCall={deleteContact} enable={true}/>

            {/* Importing properties */}
            <Upload show={showImportPopup} handleClose={handleImportPopupClose} id={-1} setUpload={setUpload} uploadstate={uploadstate} setLoadEnd={setLoadEnd} loadend={loadend} setUploaderror={setUploaderror} uploaderror={uploaderror} created={created} pageType="Contacts"/>
            
            {contactEmail != ""  && 
            <Snackbars error="" open={openEmailSuccess} setOpen={(value) => handleSnackbarClose(value)} severity="success" message={emailSuccessMessage}/>}
        </div>
    );
}

export default Contacts;